import LegalPolicyPage from './LegalPolicyPage';
export default function Terms() {
  return <LegalPolicyPage slug="terms" fallbackTitle="Terms & Conditions" />;
}
